import { __assign } from 'tslib';
import { props } from './props.js';

/**
 * These theme properties should be considered legacy. Make efforts to avoid new usage as well as refactor out existing
 * usage.
 */
var adminLightPlaceholder = { placeholder: 'rgba(0, 0, 0, 1)' };
var adminDarkPlaceholder = { placeholder: 'rgba(255, 255, 255, 0.37)' };
var adminThemeStatus = {
    status: {
        disabled: {
            opacity: 0.55,
        },
    },
};
var BASE_Z_INDEX = 1100000;
var adminThemeZIndex = {
    zIndex: {
        mobileStepper: BASE_Z_INDEX + 1000,
        appBar: BASE_Z_INDEX + 1100,
        drawer: BASE_Z_INDEX + 1200,
        modal: BASE_Z_INDEX + 1300,
        snackbar: BASE_Z_INDEX + 1400,
        tooltip: BASE_Z_INDEX + 9100,
    },
};
/** The defaults for MuiInputBase and MuiInputLabel can be removed once the BasicForm & 'shared' inputs have either:
 * 1. been refactored to use secondary color.
 * 2. been replaced with new common components.
 *
 * props as imported from './props' are part updated design system.
 */
var adminThemeDefaultProps = {
    props: __assign(__assign({}, props), { 
        // Legacy below
        MuiCard: {
            elevation: 0,
        }, MuiTooltip: {
            title: '',
            placement: 'right',
        }, MuiPaper: {
            elevation: 0,
        }, MuiAppBar: {
            position: 'static',
        }, MuiInputBase: {
            color: 'secondary',
        }, MuiInputLabel: {
            color: 'secondary',
        } }),
};

export { BASE_Z_INDEX, adminDarkPlaceholder, adminLightPlaceholder, adminThemeDefaultProps, adminThemeStatus, adminThemeZIndex };
//# sourceMappingURL=customThemeProperties.js.map
